// composables/useTalentPoolModal.ts
import { ref, computed } from 'vue'
import type { TalentPoolFormExposed } from '@/types/talentPoolForm'

export function useTalentPoolModal() {
  const open = ref(false)
  const formRef = ref<TalentPoolFormExposed | null>(null)

  const show = () => (open.value = true)
  const close = () => (open.value = false)

  const wizardMeta = computed(() => {
    const form = formRef.value
    if (!form) return { step: 1, total: 1, label: '' }
    return {
      step: form.currentStepIndex + 1,
      total: form.steps.length,
      label: form.currentStep.label,
    }
  })

  return { open, formRef, wizardMeta, show, close }
}